import { Component, OnInit } from '@angular/core';
import { slideInAnimation } from './animations';
import { UpdateService } from './update.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [ slideInAnimation ]
})
export class AppComponent implements OnInit {

  constructor(
    // private updateService : UpdateService
    ) { }

  ngOnInit() {
    sessionStorage.setItem( '1' , 'true');
    // this.updateService.checkForUpdate();
  }

}
